import React from 'react';
import microImage from '../assets/images/about/micro.jpg';

const ManifestoPage = () => {
  return (
    <section className="bg-white py-12">
      {/* Image centrée et petite */}
      <div className="flex justify-center mb-8">
        <img
          src={microImage}
          alt="AmplifyMyCom AI Microphone"
          className="w-64 h-auto object-contain rounded shadow"
        />
      </div>

      {/* Texte */}
      <div className="max-w-3xl mx-auto px-4 text-gray-800 leading-relaxed space-y-4">
        <h1 className="text-3xl font-bold text-center mb-6">
          Manifeste d’AmplifyMyCom
        </h1>

        <p>
          Chez AmplifyMyCom, nous croyons qu’un autre usage de la parole est possible.
        </p>
        <p>
          À l’heure où l’intelligence artificielle peut produire du contenu à la chaîne,
          nous faisons un choix différent : mettre la technologie au service de la justesse,
          de l’authenticité, et de l’impact.
        </p>
        <p>
          Nous aidons les organisations à mieux exprimer leur vision, leurs engagements,
          et leur valeur. Pas en les remplaçant. <strong>En les amplifiant.</strong>
        </p>
        <p>
          Parce que la communication n’est pas une vitrine, c’est un levier de transformation.
        </p>
        <p>
          Parce que la performance ne se construit pas contre le sens, mais avec lui.
        </p>
        <p>
          Parce que dans un monde saturé de messages, la clarté devient un acte de courage.
        </p>

        <p>
          <strong>AmplifyMyCom</strong>, c’est un collectif d’êtres humains et d’intelligences
          augmentées au service de celles et ceux qui veulent parler juste — et agir en cohérence.
        </p>
        <p>
          Nous concevons l’IA non comme un substitut, mais comme un levier pour libérer les idées,
          amplifier les convictions, et accélérer ce qui fait sens — pour les entreprises,
          pour leurs équipes, pour la société.
        </p>
        <p>
          Nous accompagnons celles et ceux qui veulent parler juste, plutôt que parler fort.
        </p>

        <p>
          Des dirigeant·es qui veulent embarquer.  
          Des marques qui veulent s’engager.  
          Des collaborateurs qui veulent contribuer.
        </p>

        <p>
          Parce que le bruit ne fait pas l’impact.  
          Parce que le sens ne se décrète pas.  
          Parce que les récits ne transforment que lorsqu’ils sont incarnés.
        </p>

        <h2 className="text-xl font-semibold mt-6">Nos engagements :</h2>
        <ul className="list-disc list-inside">
          <li><strong>Responsabilité :</strong> nous développons une IA transparente, éthique, et alignée avec les valeurs humaines.</li>
          <li><strong>Sobriété :</strong> nos technologies sont conçues pour être utiles, pas envahissantes.</li>
          <li><strong>Transmission :</strong> nous révélons les expertises et favorisons l’expression de chacun·e dans son registre, son ton, sa voix.</li>
        </ul>

        <p>
          Chez AmplifyMyCom, nous croyons à une nouvelle ère de la communication :
          plus stratégique, plus collective, plus responsable.
        </p>
        <p>
          Celle où chaque mot est une brique de confiance.
          Et où la technologie est au service du lien.
        </p>
      </div>
    </section>
  );
};

export default ManifestoPage;
